import { useRouteLoaderData } from "@remix-run/react";

import type { loader } from "~/root";

export default function useRootData() {
	return useRouteLoaderData<typeof loader>("root");
}
